module.exports = __webpack_public_path__ + "static/media/dollar-with-red-circle.6fde0c5d.svg";